import { FC, useRef } from 'react';
import { Flex } from 'antd';
import {
  SDropdown,
  ErrorMessage,
  SLabelTitle,
  ModalDialog,
  UploadButton,
  SInput,
  SDatePicker,
} from '../../';
import { IProps } from './type';
import styles from '../../../assets/styles/index.module.scss';
import dayjs from 'dayjs';
import { useAppSelector } from '../../../store';
import customParseFormat from 'dayjs/plugin/customParseFormat';
import { DATE_FORMAT } from '../../../assets/conts';
import globalStyles from '../../../assets/styles/index.module.scss';
import { useSetOrganizationOnOpen } from '../../../hooks';

dayjs.extend(customParseFormat);

const PolicyModal: FC<IProps> = (props) => {
  const { getFieldProps, setFieldValue, values, errors, touched } =
    props.formik;
  const uploadInput = useRef<HTMLInputElement | null>(null);
  const { organization } = useAppSelector(
    (state) => state.userReducer.userInfo,
  );

  useSetOrganizationOnOpen(props.open, values, setFieldValue);

  return (
    <ModalDialog
      title={props.title}
      subTitle={props.subTitle}
      open={props.open}
      handleOk={props.handleSubmit}
      handleCancel={props.handleCancel}
    >
      <Flex gap="middle" vertical>
        <Flex align="flex-start" justify="space-between">
          <SLabelTitle>Şirket Bilgileri</SLabelTitle>
          <Flex vertical gap="small">
            <SDropdown
              id="organization"
              value={
                props.organizations.find(
                  (item) =>
                    item.id ===
                    (values.organization ||
                      (organization !== 1 ? organization : undefined)),
                )?.name
              }
              placeholder="Şirket Seçiniz"
              className={globalStyles.width200px}
              disabled={organization !== 1}
              options={props.organizations.map((item) => ({
                value: item.id,
                label: item.name,
              }))}
              onChange={(value) => setFieldValue('organization', value)}
            />
            {touched.organization && errors.organization && (
              <ErrorMessage>{errors.organization}</ErrorMessage>
            )}
          </Flex>
        </Flex>
        <Flex gap="small" vertical>
          <SLabelTitle>Poliçe Bilgileri</SLabelTitle>
          <Flex justify="space-between" gap="small">
            <Flex vertical gap="small" className={styles.widthHalf}>
              <SDropdown
                id="policy_type"
                value={values.policy_type}
                placeholder="Poliçe Tipi"
                options={props.policyTypes.map((pt) => ({
                  value: pt.key,
                  label: pt.value,
                }))}
                onChange={(value) => setFieldValue('policy_type', value)}
              />
              {touched.policy_type && errors.policy_type && (
                <ErrorMessage>{errors.policy_type}</ErrorMessage>
              )}
            </Flex>
            <Flex vertical gap="small" className={styles.widthHalf}>
              <SInput
                placeholder="Poliçe No"
                {...getFieldProps('policy_number')}
              />
              {touched.policy_number && errors.policy_number && (
                <ErrorMessage>{errors.policy_number}</ErrorMessage>
              )}
            </Flex>
          </Flex>
        </Flex>
        <UploadButton
          fileName={[...values.upload_files]?.map((item) => item.name)}
          uploadRef={uploadInput}
          onChange={props.handleUploadFile}
        />
        <></>
        {values.policy_type !== 'nakliyat_sefer_poliçesi' && (
          <Flex gap="small" vertical>
            <SLabelTitle>Tarih Aralıgı</SLabelTitle>
            <Flex justify="space-between" gap="small">
              <Flex vertical gap="small" className={styles.widthHalf}>
                <SDatePicker
                  id="start_date"
                  name="start_date"
                  value={
                    values.start_date
                      ? dayjs(values.start_date, DATE_FORMAT)
                      : null
                  }
                  className={styles.input}
                  placeholder="Başlangıç Tarihi"
                  onChange={(date) => {
                    if (date) {
                      setFieldValue('start_date', date.format(DATE_FORMAT));
                    }
                  }}
                />
                {touched.start_date && errors.start_date && (
                  <ErrorMessage>{errors.start_date}</ErrorMessage>
                )}
              </Flex>
              <Flex vertical gap="small" className={styles.widthHalf}>
                <SDatePicker
                  id="end_date"
                  name="end_date"
                  value={
                    values.end_date ? dayjs(values.end_date, DATE_FORMAT) : null
                  }
                  className={styles.input}
                  placeholder="Bitiş Tarihi"
                  onChange={(date) => {
                    if (date) {
                      setFieldValue('end_date', date.format(DATE_FORMAT));
                    }
                  }}
                />
                {touched.end_date && errors.end_date && (
                  <ErrorMessage>{errors.end_date}</ErrorMessage>
                )}
              </Flex>
            </Flex>
          </Flex>
        )}
      </Flex>
    </ModalDialog>
  );
};

export default PolicyModal;
